export default "__VITE_ASSET__ByqgRPZ6__"